import * as Types from '../constants/Types'

const initialState = {
    isDownloading: false
}

export default (state = initialState, action) => {
    switch(action.type) {
        case Types.EXPORT_BUNDLE_REPORT_EXCEL: 
            return {...state, isDownloading: true}
        case Types.EXPORT_BUNDLE_REPORT_EXCEL_SUCCESS: 
            return {...state, isDownloading: false}
        case Types.EXPORT_BUNDLE_REPORT_EXCEL_FAIL: 
            return {...state, isDownloading: false}
        default: 
            return state
    }
}